import { api } from '@astro/api'

/**
 * Booking checkout is reserve-then-pay: POST /bookings has to create the row
 * before a Razorpay order can be made for it, so a booking exists for a few
 * seconds before any money moves. It is created `pending` and the backend
 * treats a pending unpaid row as a checkout, not an appointment — only
 * POST /razorpay/verify confirms it.
 *
 * What was still wrong: dismissing the Razorpay modal left that reservation
 * behind, so "Proceed to payment" alone put a booking in the seeker's list and
 * held the slot (for UNPAID_HOLD_MINUTES) without a single rupee paid. Every
 * checkout that doesn't end in a verified payment releases its reservation
 * here instead.
 *
 * Best effort and never throws: the backend's hold also lapses on its own, so
 * a failed release is untidy, not harmful — never worth showing the seeker an
 * error about a booking they already walked away from.
 */
export async function releaseUnpaidBooking(bookingId, reason = 'Payment not completed') {
  if (!bookingId) return false
  try {
    await api.bookings.cancel(bookingId, reason)
    return true
  } catch {
    return false
  }
}
